import React from 'react'
import styles from './Question.module.css'
import QuestionCard from './QuestionCard'

export default function Question() {
    const questions = [
        {
            question: '採用時の料金はどのくらいですか？',
            answer: '企業様に合わせて最適なプランをご用意しております。まずはお問い合わせください。',
        },
        {
            question: 'スカウトは何通まで送れますか？？',
            answer: 'スカウトも、企業様に合わせたプランをご用意しております！お問い合わせください。',
        },
        {
            question: '急ぎで採用したいです。',
            answer: (
                <>
                    自社運用媒体のため、アカウント発行後すぐに求人掲載が可能です。
                    <br />
                    また、エージェントサポートを併用することで、スムーズな採用も見込めます。
                </>
            ),
        },
    ]

    return (
        <section id='question' className={styles.question}>
            <h1>よくある質問</h1>
            <div className={styles.questionBox}>
                {questions.map((q, index) => (
                    <QuestionCard
                        key={index}
                        question={q.question}
                        answer={q.answer}
                    />
                ))}
            </div>
        </section>
    )
}
